import { render, staticRenderFns } from "./TableListPurchaseBuyer.vue?vue&type=template&id=2352cd48&"
import script from "./TableListPurchaseBuyer.vue?vue&type=script&lang=ts&"
export * from "./TableListPurchaseBuyer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports